var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeviceMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 3.85A1.15 1.15 0 0 0 6.85 5v14A1.15 1.15 0 0 0 8 20.15h8A1.15 1.15 0 0 0 17.15 19V5A1.15 1.15 0 0 0 16 3.85zm-2.015-.865A2.85 2.85 0 0 1 8 2.15h8A2.85 2.85 0 0 1 18.85 5v14A2.85 2.85 0 0 1 16 21.85H8A2.85 2.85 0 0 1 5.15 19V5c0-.756.3-1.48.835-2.015",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.15 4c0-.47.38-.85.85-.85h2a.85.85 0 0 1 0 1.7h-2a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 16.15c.47 0 .85.38.85.85v.01a.85.85 0 0 1-1.7 0V17c0-.47.38-.85.85-.85",
  clipRule: "evenodd"
})));
export default SvgDeviceMobile;